
import { i18nText } from '@/locales';

import { Component, Vue, Watch } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import AppSimpleLink from "@/UI/components/Link/AppSimpleLink.vue";
import { mixins } from "vue-class-component";

import { ProductsMix } from "@/UI/mixins/Store/ProductsMix";
import { ProductsTableMix } from "@/UI/mixins/Store/ProductsTableMix";
import { ProductsCategoriesMix } from "@/UI/mixins/Store/ProductsCategoriesMix";
import { ProductsCategoriesStore } from "@/store/modules/Warehouse/ProductsCategories";
import { ProductsCategoriesTableMix } from "@/UI/mixins/Store/ProductsCategoriesTableMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {
  IProductsCategoryTypes,
  ProductsCategoryUpdateRequestType,
} from "@/entity/warehouse/Products/Category/Category.types";

import { Button, Menu, List, Table, Select, Row, Col } from "ant-design-vue";

import {
  CategoryFormData,
  CategoryFormRules,
  CategorySelectRules,
  CategorySelectForm,
} from "@/form/Warehouse/Category/Category";

import { FormModel } from "ant-design-vue/types/form-model/form";
import { ProxyGetData } from "@/UI/components/Helpers/getData";
import { showNotification } from "@/UI/lib/messages";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
import { getStudioId } from "@/UI/lib/state";
import { appPaginationStore } from "@/store/modules/appPagination";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import { isObjectsEqual } from "@/UI/lib/support";
import { showNotificationSimple } from "@/UI/lib/messages";

@Component({
  components: {
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-row": Row,
    "a-col": Col,

    PageTitle,
    BaseDataForm,
    AppSimpleLink,
    SortComponent
  },
})
export default class Products extends mixins(
  ProxyTableData,
  ProductsCategoriesTableMix,
  ProductsCategoriesMix,
  ProductsMix,
  ProductsTableMix,
  ProxyGetData
) {


  canArchived = false;
  showModal = false;
  //RouteNameE = RouterNameEnum;
  showCategorySelectModal = false;
  categoryEditMode = 0;
  StoreId = this.$route.params.Store;
  categoryId = 0;
  loading = true;
  modalTitle = "";
  index_filter: any = 0
  form = new CategoryFormData();
  categoryForm = new CategorySelectForm();
  index_for_table: any = ''
  rules = CategoryFormRules;
  categoryRules = CategorySelectRules;
  Category = ProductsCategoriesStore.dataCategory;
  Categories = ProductsCategoriesStore.dataCategories;
  products_sort: any = []
  // tree_data: any = []
  // tree_data_children: any = []
  //Studio_Id = this.$store.state.salon_id;

  onSearch(search: any): void {
    //setRouteFilter(RouterNameEnum.ListedProducts, { name: search }, true);
    this.proxyFilter['search'] = search;
    this.getProducts();
  }

  async sortArrList() {
    //await ProductsCategoriesStore.fetchAll({filter: {salon_id: getStudioId(this)}})
    let products_arr_sort: any = ProductsCategoriesStore.productsCategories
    products_arr_sort.sort((a: any, b: any) => a.name.localeCompare(b.name))
    this.products_sort = products_arr_sort
    //Дерево категорий, не доделано и временно вырезано
    // this.products_sort.forEach((i: any) => {
    //     if (i.children) {
    //         for(let t = 0; t < i.children.length; t++) {
    //             this.tree_data_children.push({title: i.children[t].name})
    //         }
    //         this.tree_data.push({
    //             title: i.name,
    //             children: this.tree_data_children
    //         })
    //     } else {
    //         this.tree_data.push({
    //             title: i.name,
    //             children: []
    //         })
    //     }
    // })
    // this.products_sort.length = 0
  }

  confirm(e: string): any {
    this.$message.success("Click on Yes");
  }

  cancel(e: string): any {
    this.$message.error("Click on No");
  }

  createProduct(): void {
    try {
      this.showCategorySelectModal = false;
      this.$router.push({
        name: this.$routeRules.StoresProductsCreate,
        params: {
          Studio: getStudioId(this),
          fromCategory: String(0)
        },
      });
    } catch (e) {
      console.log("Error create product");
    }
    //this.showCategorySelectModal = true;
  }

  get category(): IProductsCategoryTypes | null {
    return ProductsCategoriesStore.dataCategory;
  }

  async showAllProducts(): Promise<void> {
    await Vue.router.push({
      name: this.$routeRules.ListedProducts,
      params: {
        idCategory: "0",
      },
    });
    await this.getProducts();
  }

  async openCategoryLink(index: string): Promise<void> {
    await Vue.router.push({
      name: this.$routeRules.ListedProducts,
      params: {
        idCategory: index,
      },
    });
    await this.getProducts(Number(index))
  }

  onCategorySubmit(): void {
    (this.$refs.categorySelectForm as FormModel).validate((valid) => {
      if (valid) {
        try {
          this.showCategorySelectModal = false;
          this.$router.push({
            name: this.$routeRules.StoresProductsCreate,
            params: {
              fromCategory: String(this.categoryForm.id),
              Studio: getStudioId(this),
              Store: this.StoreId,
            },
          });
        } catch (e) {
          console.log("Error create product");
        }
      }
    });

    /*this.router.push({
    name: this.$routeRules.StoresProductsCreate,
    params: { fromCategory: '1', Studio: this.Studio_Id, Store: this.StoreId },
});*/
  }

  handleCategoryCancel(): void {
    this.showCategorySelectModal = false;
  }

  @Watch("proxyFilter.salon_id", { immediate: false })
  async onProxyFilterSalonChange(): Promise<void> {
    await this.getCategories(getStudioId(this));
    await this.sortArrList();
  }

  async onSubmit(): Promise<void> {
    try {
      if (this.categoryEditMode === 0) {
        try {
          await ProductsCategoriesStore.create(this.form).then((response) => {
            showNotification(i18nText("Добавление категории -") + this.form.name, response);
          });
          await this.sortArrList()
        } catch (e) {
          console.log("Error create products categories");
        } finally {
          await this.getCategories(getStudioId(this));
          await this.sortArrList();
        }
        //this.$message.info("Категория успешно создана!");
      }
      if (this.categoryEditMode === 1) {
        try {
          const formData: ProductsCategoryUpdateRequestType = this.form;
          await ProductsCategoriesStore.update(formData).then((response) => {
            showNotification(i18nText("Обновление категории -") + this.form.name, response);
          });
          await this.sortArrList()
        } catch (e) {
          console.log("Error update products categories");
        } finally {
          await this.getCategories(getStudioId(this));
          await this.sortArrList();
        }
      }
    } catch (e) {
      console.log("Error save data -" + e);
    }
    this.showModal = false;
  }

  handleCancel(): void {
    this.showModal = false;
  }

  async onDelete(): Promise<void> {
    try {
      ProductsCategoriesStore.delete(this.categoryId).then((response) => {
        showNotification(i18nText("Удаление категории"), response);
        this.showModal = false;
      });
      await this.sortArrList()
    } catch (e) {
      console.error(e)
    } finally {
      await this.getCategories(getStudioId(this));
      await this.sortArrList();
    }
  }

  async editCategory(id: number): Promise<void> {
    this.categoryId = id;
    await ProductsCategoriesStore.fetchData({ filter: { id: id } }).then((data) => {
      if (this.category !== null) this.form.setFormData(this.category);
    });
    this.modalTitle = i18nText("изменить");
    this.categoryEditMode = 1;
    this.showModal = true;
    this.loading = false;
  }

  async addCategory(): Promise<void> {
    this.form = new CategoryFormData();
    this.form.salon_id = getStudioId(this);

    this.modalTitle = i18nText("Создать категорию");
    this.categoryEditMode = 0;

    this.showModal = true;
    this.loading = false;
  }

  handleUpdateModal(visible: boolean): void {
    this.showModal = visible;
  }

  rowOnChange(selectedRowKeys: any, selectedRows: any): void {
    this.canArchived = selectedRowKeys.length > 0;
  }

  async getProducts(fromCategory?: number): Promise<void> {
    if (fromCategory) {
      this.index_for_table = fromCategory
    }
    setTimeout(() => {
      if (this.$router.currentRoute.params["idCategory"] === this.index_filter) {
        this.index_for_table = this.index_filter
      }
    }, 100)
    if (this.$router.currentRoute.params["idCategory"] === this.$route.params['idCategory']) {
      this.proxyFilter.category_id = fromCategory ? fromCategory : this.$route.params['idCategory'];
    }
    if (this.$router.currentRoute.params["idCategory"] === '0') {
      this.proxyFilter = {}
    }
    /*if (this.$router.currentRoute.params["idCategory"] === 0 as any) {
      this.proxyFilter = {
        category_id: this.index_filter
      }
      await Vue.router.push({
        name: this.$routeRules.ListedProducts,
        params: {
          idCategory: this.index_filter,
        },
      });
    }*/
    await this.createProxy();
  }

  async setIndexFilter(): Promise<void> {
    if (ProductsCategoriesStore.productsCategories) {
      this.index_filter = ProductsCategoriesStore.productsCategories![0].id
      if (this.index_filter && this.$route.params.idCategory !== this.index_filter.toString()) {
        await Vue.router.push({
          name: this.$routeRules.ListedProducts,
          params: {
            idCategory: this.index_filter,
          },
        });
      }
    }
  }

  async created(): Promise<void> {
    this.tableLoad = false;
    try {
      await this.getCategories(getStudioId(this));
      const studio = getStudioId(this);
      this.proxyFilter = {
        salon_id: getStudioId(this)
      }
      appPaginationStore.setCurrent(1)
      await this.getData();
      await this.setDefaultCategoryWcd();
      await this.sortArrList();
      console.log("created try")
      await this.sortedData('desc', { dataIndex: 'created_at' })
      await this.fetchModules([
        { s: 'category', p: { limit: -1 } }
      ])
    } catch (e) {
      console.error(e);
      console.error(e.message);
    } finally {
      this.formReady = true;
      this.tableLoad = true;
      console.log("created finally")

    }
  }

  async setFilter({ by, sort }: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, { dataIndex: sort.dataIndex })
  }
}
